import {
    RequestService,
    RequestServiceResponse,
} from '@tcc-online/request-service';

import IRegistration from '../../types/auth/IRegistration';
import { StorageService } from './StorageService';
import { isSuccessfulResponse } from '../../helpers';

const ENDPOINT = '/participant/registrations';
export const REGISTRATION_DATA_KEY = 'reg_data+';

const RegistrationService = {
    getRegistration,
    postRegistration,
};

async function getRegistration(
    id: string,
): Promise<RequestServiceResponse<IRegistration>> {
    return await RequestService.get<IRegistration>(
        `${ENDPOINT}/${id}`,
        {},
        { ignoreAuth: true },
    );
}

type RegistrationPayload = {
    id: string;
    email: string;
    firstName: string;
    lastName: string;
    category: string;
    restrictRegistration: boolean;
    params?: string;
};

async function postRegistration(
    payload: Partial<RegistrationPayload>,
): Promise<RequestServiceResponse<{ email?: string; urlToken?: string }>> {
    const { id, restrictRegistration, params, ...rest } = payload;
    const data: Partial<RegistrationPayload> = rest;

    if (params) {
        data.params = params;
    }

    const result = await RequestService.post<
        Partial<RegistrationPayload>,
        { email?: string; urlToken?: string }
    >(`${ENDPOINT}/${id}/users`, rest, {
        ignoreAuth: true,
    });

    if (
        restrictRegistration &&
        result?.status &&
        isSuccessfulResponse(result.status) &&
        result.data
    ) {
        StorageService.setLocal(REGISTRATION_DATA_KEY + id, {
            urlToken: result.data.urlToken,
            email: result.data.email,
        });
    }

    return result;
}

export default RegistrationService;
